import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ShipTestState {
  shipTestData: any;
  // ... other state properties
}

const initialState: ShipTestState = {
  shipTestData: {},
  // ... other initial state
};

const shipTestSlice = createSlice({
  name: 'shipTest',
  initialState,
  reducers: {
    setShipTestData: (state, action: PayloadAction<any>) => {
      state.shipTestData = action.payload;
    },
    // ... other reducers
  }
});

export const { setShipTestData } = shipTestSlice.actions;
export default shipTestSlice.reducer; 